import {Environment} from '../Routes';

export function logVersion() {
	// todo the version should be dinamic
	console.log(`Thrive 23.2.1 ${Environment.getCurrentEnvironment()} started`);
}
